<template>
  <div>
    <div class="mass-action-settings">

      <cards-stage-select
        v-model="actionData.stage_type"
        placeholder="Выберите этап"
        size="small"
      ></cards-stage-select>

      <cards-stage-negotiation-select
        v-model="actionData.prev_negotiation"
        placeholder="Выберите шаг после которого добавить"
        size="small"
        style="margin-left: 20px"
      ></cards-stage-negotiation-select>

      <el-select
        v-model="actionData.prev_negotiation_order"
        placeholder="Номер по порядку"
        size="small"
        style="margin-left: 20px"
      >
        <el-option
          v-for="order in 5"
          :key="order"
          :label="order"
          :value="order"
        >
        </el-option>
      </el-select>

      <div style="margin-top: 20px">Настройки нового шага</div>
      <negotiation-edit-form
        v-model="actionData.negotiation"
        style="width:350px"
      ></negotiation-edit-form>




      <el-popconfirm
        confirm-button-text='Да'
        cancel-button-text='нет'
        icon="el-icon-question"
        title="Вы уверены, что хотите создать шаг?"
        @confirm="doAction"
      >
        <el-button
          slot="reference"
          style="margin-top: 20px"
          size="small"
          type="primary"
          :disabled="actionButtonDisabled"
        >
          Создать
        </el-button>

      </el-popconfirm>

    </div>

    <mass-action-result
      v-if="result"
      :result="result"
    ></mass-action-result>
  </div>
</template>

<script>
import {ActionTemplateMixin} from "@/components/massActions/actionTemplates/ActionTemplateMixin";
import MassActionResult from "@/components/massActions/MassActionResult.vue";
import CardsStageNegotiationSelect from "@/components/filters/cards/CardsStageNegotiationSelect.vue";
import NegotiationEditDialog from "@/components/cards/CardStagesBlock/NegotiationEditDialog.vue";
import CardsStageSelect from "@/components/filters/cards/CardsStageSelect.vue";
import NegotiationEditForm from "@/components/cards/CardStagesBlock/NegotiationEditForm.vue";

export default {
  name: "card-create-negotiation-action",
  mixins: [ActionTemplateMixin],
  components: {
    NegotiationEditForm,
    CardsStageSelect, NegotiationEditDialog, CardsStageNegotiationSelect, MassActionResult},

  computed: {
    actionButtonDisabled() {
      return !this.actionData.negotiation
        || !this.actionData.stage_type
        || !this.actionData.prev_negotiation;
    }
  },

  data() {
    return {
      actionData: {
        stage_type: null,
        prev_negotiation: null,
        prev_negotiation_order: null,
        negotiation: {},
      }
    }
  },
  methods: {
    doAction(){
      this.actionData.negotiation_type = this.actionData.negotiation.type;
      this.actionData.description = this.actionData.negotiation.description;
      this.actionData.user_id = this.actionData.negotiation?.user?.id;

      this.$emit('do-action', this.actionData)
    }
  },
}
</script>
